import { Alert, Text } from 'bold-ui'

interface AlertaInsulinaNphProps {
  inline?: boolean
}

export function AlertaInsulinaNph(props: Readonly<AlertaInsulinaNphProps>) {
  const { inline = true } = props

  return (
    <Alert type='warning' inline={inline || undefined}>
      O SUS iniciou a transição da insulina NPH.{' '}
      <Text fontWeight='bold' color='inherit'>
        Recomenda-se efetuar a troca do tratamento para Insulina Glargina
      </Text>{' '}
      em crianças e adolescentes com DM1 (igual ou superior a 2 anos e menores de 18 anos) e pessoas com 70 anos ou mais
      (DM1 ou DM2).
    </Alert>
  )
}
